export default "__VITE_ASSET__CYzhNNAD__"